import { useSelector } from 'react-redux';
import CurrencyPrice from '../currency-price/currency-price';
import useSale from '../../hooks/use-sale';
import translation from '../../languages';
import cn from '../../utils/classnames';
import { isFreeMaterial } from '../../utils/material/material-helper';
import formatPrice from '../../utils/price/format-price';
import { ZERO_PRICE_TEXT } from '../../constants/price';
import './price-with-currency.scss';

type PricePropsType = TranslationProps & {
    item: Material;
    hideOldPrice?: boolean;
    oldPrice?: number;
};

const PriceWithCurrency = (props: PricePropsType) => {
    const { item, hideOldPrice, oldPrice, t } = props;

    const { countryCode } = useSelector((state: RootState) => state.main.geotargeting);
    const translationForFree = t('materialPage.priceBlock.forFree');
    const { isSale, isFreeSale } = useSale(item, countryCode);

    const materialIsFree = isFreeMaterial(item);

    return (
        <div className='current-old-price-container tsc-subheadline text-left mb-2 d-flex align-items-baseline'>
            <span
                className={cn('current-price mr-2 price-with-currency', {
                    free: materialIsFree,
                    sale: isSale,
                    'free-sale': isFreeSale
                })}
            >
                {materialIsFree ? translationForFree : <CurrencyPrice price={item.price} />}
            </span>
            {!hideOldPrice &&
                (oldPrice && !isSale ? (
                    <span className='paket-price strike-through price-with-currency'>
                        <CurrencyPrice price={oldPrice} />
                    </span>
                ) : (
                    <span className='strike-through price-block-before-sale-price price-with-currency'>
                        {isSale &&
                            (formatPrice(item?.sale?.original_price) !== ZERO_PRICE_TEXT ? (
                                <CurrencyPrice price={item?.sale?.original_price} />
                            ) : (
                                translationForFree
                            ))}
                    </span>
                ))}
        </div>
    );
};

const translate = translation('material-page');

export default translate(PriceWithCurrency);
